const initialState = {
    userCountryCode: "",
    stateCode: "",
    allSelectedTNC:false,
    currencyCode:[],
    /** `null` = not loaded; object = Hendrix fetch result for `SPP_PAYMENT_EVENTS` (may be `{}`). */
    sppPaymentEventsMessage: null,
};

const UserInfoReducer  = (state=initialState,action) => {
    switch(action.type){
        case 'SET_COUNTRY':{
            return  {
                ...state,
                userCountryCode:action.value
            }
        } 
        case 'SET_COUNTRY_STATES' : {
            return {
                ...state,
                countryStates : action.value
            }
        }
        case 'SET_COUNTRY_CURRENCY' : {
            return {
                ...state,
                currencyCode : action.value
            }
        }
        case 'SET_STATE' : {
            return {
                ...state,
                stateCode : action.value
            }
        }
        case 'SET_EVENT_TERM_CONDITION' : {
            return {
                ...state,
                eventTermsCondition : action.value
            }
        }
        case 'SET_TERM_CONDITION_ACCEPTED' : {	
            return {	
                ...state,	
                termsConditionAccepted : action.value	
            }	
        }
        case 'SET_EVENT_WALLET_APP' : {	
            return {	
                ...state,	
                eventMiniWallet : action.value	
            }	
        }
        case 'SET_PI_PARITY_APP' : {
            return {
                ...state,
                piParityApp: action.value,
            };
        }
        case 'SET_SPP_PAYMENT_EVENTS_MESSAGE': {
            return {
                ...state,
                sppPaymentEventsMessage: action.value,
            };
        }
        default:
            return state;
    }

};

export default UserInfoReducer;
